export interface Pagination {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
}

export class PagedList<T> {
    items:  Array<T>;
    pagination: Pagination; 
}
